import { StandardCard } from '@juvare/common-web-ui/Cards/StandardCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Stack, Typography } from '@mui/material';
import React from 'react';
export const ImportDialogCard = (props) => {
    return (React.createElement(StandardCard, { sx: {
            backgroundColor: themeColors.surface.secondary,
            border: 0,
            p: 2,
            height: '100%',
        } },
        React.createElement(Stack, { direction: 'row', spacing: 1 },
            props.icon,
            React.createElement(Stack, { spacing: 0.5 },
                React.createElement(Typography, { variant: 'subtitle2', color: themeColors.text.main }, props.title),
                typeof props.description === 'string' ? (React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, props.description)) : (props.description)))));
};
